import { createApp } from "vue";
import QuickShipFilter from "../components/quick-ship-filter/QuickShipFilter";
import availabilityFilters from "./availability-filters";

const c = {
  dom: {
    quickShipFilterToolbarContainer: "quickShipFilterToolbarContainer",
    quickShipFilterContainer: "quickShipFilterContainer",
    productsGrid: "productsGrid",
    quickShipFilter: "js-quick-ship-filter-badge"
  },
  cls: {
    hide: "hide",
    isActive: "is-active",
    isSelected: "is-selected"
  }
};

const $quickShipFilterToolbarContainer = document.getElementById(c.dom.quickShipFilterToolbarContainer);
const $quickShipFilterContainer = document.getElementById(c.dom.quickShipFilterContainer);
const $productsGrid = document.getElementById(c.dom.productsGrid);

export const isQuickShipActivated = () => {
  const $quickShipFilters = document.querySelectorAll(`.${c.dom.quickShipFilter}`);
  return Array.from($quickShipFilters).some(($el) => __.hasClass($el, c.cls.isSelected));
};

function quickShipFilterApp() {
  /**
   * Filter products based on Quick Ship tag
   */
  function filterProductsByQuickShip(active) {
    if (!$productsGrid) {
      return;
    }
    if (!active) {
      availabilityFilters.showAllProducts();
      return;
    }

    const $productWrappers = $productsGrid.querySelectorAll(".product-item__wrapper");
    let visibleProductCount = 0;
    $productWrappers.forEach(($productWrapper) => {
      const $productItem = $productWrapper.querySelector("[data-product-id]") || $productWrapper;
      const isQuickShip = $productItem.dataset.isQuickShip === "true";
      
      const method = isQuickShip ? "removeClass" : "addClass";
      __[method]($productWrapper, c.cls.hide);
      if (isQuickShip) visibleProductCount += 1;
    });

    availabilityFilters.toggleNoResultsMessage(visibleProductCount > 0);

    if (active && visibleProductCount < 5) {
      window.dispatchEvent(new CustomEvent("requestMoreProducts"));
    }
  }

  /**
   * Hide/show Quick Ship filter containers
   */
  function toggleQuickShipFilterVisibility(show) {
    if (!$quickShipFilterToolbarContainer || !$quickShipFilterContainer) {
      return;
    }
    [$quickShipFilterToolbarContainer, $quickShipFilterContainer].forEach(($el) => {
      __[show ? "removeClass" : "addClass"]($el, c.cls.hide);
    });
  }

  function init() {
    // Only show Quick Ship filter if collection metafield is enabled and products have quick ship tag
    if (!$quickShipFilterToolbarContainer && !$quickShipFilterContainer) {
      return;
    }

    // Mount toolbar component (desktop)
    if ($quickShipFilterToolbarContainer) {
      const toolbarApp = createApp(QuickShipFilter);
      toolbarApp.mount("#quickShipFilterToolbarContainer");
    }

    // Mount filter sidebar component (mobile)
    if ($quickShipFilterContainer) {
      const filterApp = createApp(QuickShipFilter);
      filterApp.mount("#quickShipFilterContainer");
    }

    // Listen for Quick Ship filter changes
    window.addEventListener("quickShipFilterChanged", (event) => {
      if (event.detail && event.detail.active !== undefined) {
        filterProductsByQuickShip(event.detail.active);
      }
    });

    // Listen for Same Day Pickup activation - hide Quick Ship filter
    window.addEventListener("quickShipDeactivated", () => {
      toggleQuickShipFilterVisibility(false);
    });

    // Listen for Same Day Pickup deactivation - show Quick Ship filter
    window.addEventListener("quickShipActivated", () => {
      toggleQuickShipFilterVisibility(true);
    });
  }

  init();

  return {
    filterProductsByQuickShip
  };
}

export const quickShipFilterAppInstance = quickShipFilterApp();

export default quickShipFilterApp = () => quickShipFilterAppInstance;
